import * as React from 'react'
import { observer, inject } from 'mobx-react'
import { StateType } from '../state/state'
import { Label } from '../../../components/ui/Label'
import { FilterButton } from '../../../components/ui/FilterButton'
import { GeoFilter } from '../types'
import { capitalize } from 'lodash-es'
import { GEO_FILTER } from '../constants'

interface Props {
  className?: string
  state?: StateType
}

export const RegionsButtons: React.FC<Props> = inject('state')(
  observer(({ className = '', state }) => {
    const { geoFilters, toggleGeoFilter } = state.ScatterplotState

    return (
      <div className={`-regions-buttons ${className}`}>
        <Label className="mb2" label={`${capitalize(GEO_FILTER.name)}`} />
        <div className="flex items-center flex-wrap">
          {(geoFilters as GeoFilter[]).map(({ name, isActive }) => (
            <FilterButton
              key={name}
              className=""
              isActive={isActive}
              label={name}
              onClick={() => toggleGeoFilter(name)}
            />
          ))}
        </div>
      </div>
    )
  })
)
